import { render, staticRenderFns } from "./TJDetailMenu.vue?vue&type=template&id=73451fc3&scoped=true&"
import script from "./TJDetailMenu.vue?vue&type=script&lang=js&"
export * from "./TJDetailMenu.vue?vue&type=script&lang=js&"
import style0 from "./TJDetailMenu.vue?vue&type=style&index=0&id=73451fc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73451fc3",
  null
  
)

export default component.exports